(function () {
  function escapeHtml(value) {
    return String(value == null ? '' : value)
      .replace(/&/g, '&amp;')
      .replace(/</g, '&lt;')
      .replace(/>/g, '&gt;')
      .replace(/"/g, '&quot;')
      .replace(/'/g, '&#39;');
  }

  function parseDate(dateStr) {
    if (!dateStr) return new Date(0);
    var parts = String(dateStr).split('/');
    if (parts.length !== 3) return new Date(0);
    var day = Number(parts[0]);
    var month = Number(parts[1]);
    var year = Number(parts[2]);
    return new Date(year, month - 1, day);
  }

  function normalizeReview(review) {
    return {
      id: String(review.id || ''),
      verified: Boolean(review.verified || review.verified_purchase),
      date: review.date || '',
      stars: Number(review.stars != null ? review.stars : review.rating || 5),
      title: review.title || '',
      text: review.text || '',
      author: review.author || 'Anonymous',
      product: review.product || review.product_name || '',
      category: review.category || ''
    };
  }

  function generateStarRating(stars) {
    var starCount = Math.max(0, Math.min(5, parseInt(stars, 10) || 0));
    return '\u2605'.repeat(starCount) + '\u2606'.repeat(5 - starCount);
  }

  function shuffle(array) {
    var copy = array.slice();
    for (var i = copy.length - 1; i > 0; i -= 1) {
      var j = Math.floor(Math.random() * (i + 1));
      var temp = copy[i];
      copy[i] = copy[j];
      copy[j] = temp;
    }
    return copy;
  }

  function buildDisplayList(allReviews, mode, category) {
    if (mode === 'category') {
      if (!category) return allReviews;
      var target = category.toLowerCase();
      return allReviews.filter(function (review) {
        return review.category && review.category.toLowerCase() === target;
      });
    }

    if (mode === 'featured_shuffle') {
      var featuredCategories = ['KittaParts', 'Shelves', 'Crates'];
      var featuredReviews = [];
      var featuredReviewIds = {};

      featuredCategories.forEach(function (cat) {
        var categoryReviews = allReviews
          .filter(function (review) {
            return review.category && review.category.toLowerCase() === cat.toLowerCase();
          })
          .sort(function (a, b) {
            return parseDate(b.date) - parseDate(a.date);
          });

        if (categoryReviews.length > 0) {
          var mostRecent = categoryReviews[0];
          if (!featuredReviewIds[mostRecent.id]) {
            featuredReviews.push(mostRecent);
            featuredReviewIds[mostRecent.id] = true;
          }
        }
      });

      var remainingReviews = allReviews.filter(function (review) {
        return !featuredReviewIds[review.id];
      });

      return featuredReviews.concat(shuffle(remainingReviews));
    }

    return allReviews;
  }

  function updateHeader(reviews, countEl) {
    var totalReviews = reviews.length;
    countEl.removeAttribute('aria-busy');
    if (totalReviews === 0) {
      countEl.textContent = '0 Reviews';
      return;
    }

    var totalStars = reviews.reduce(function (sum, review) {
      return sum + (review.stars || 0);
    }, 0);
    var averageRating = (totalStars / totalReviews).toFixed(2);
    countEl.textContent = totalReviews + ' Reviews (' + averageRating + ')';
  }

  function renderPage(root, displayedReviews, page, perPage) {
    var grid = root.querySelector('[data-lb-review-grid]');
    var start = page * perPage;
    var end = start + perPage;
    var reviewsToShow = displayedReviews.slice(start, end);
    var html = reviewsToShow
      .map(function (review) {
        return (
          '<div class="lb-review-item">' +
          '<div class="lb-review-date">' +
          escapeHtml(review.date) +
          '</div>' +
          '<div class="lb-review-item-stars">' +
          generateStarRating(review.stars) +
          '</div>' +
          '<div class="lb-review-title">' +
          escapeHtml(review.title) +
          '</div>' +
          '<div class="lb-review-text">' +
          escapeHtml(review.text) +
          '</div>' +
          '<div class="lb-review-footer"><div>' +
          '<div class="lb-review-author">' +
          escapeHtml(review.author) +
          '</div>' +
          '<div class="lb-product-name">' +
          escapeHtml(review.product) +
          '</div>' +
          '</div></div></div>'
        );
      })
      .join('');

    grid.innerHTML = html;
  }

  function initCarousel(root) {
    var reviewsUrl = root.getAttribute('data-reviews-url');
    if (reviewsUrl && reviewsUrl.indexOf('reviews.json') !== -1) {
      reviewsUrl = reviewsUrl.replace('reviews.json', 'lb-reviews-data.json');
    }
    var mode = root.getAttribute('data-mode') || 'all';
    var category = root.getAttribute('data-category') || '';
    var perPage = parseInt(root.getAttribute('data-per-page') || '3', 10);
    var grid = root.querySelector('[data-lb-review-grid]');
    var countEl = root.querySelector('[data-lb-review-count]');
    var prevButton = root.querySelector('[data-lb-review-prev]');
    var nextButton = root.querySelector('[data-lb-review-next]');
    var headerSource = root.getAttribute('data-header-source') || 'displayed';

    var displayedReviews = [];
    var allReviews = [];
    var currentPage = 0;
    var totalPages = 0;

    function updateNavButtons() {
      if (totalPages > 1) {
        prevButton.disabled = currentPage === 0;
        nextButton.disabled = currentPage >= totalPages - 1;
      } else {
        prevButton.disabled = true;
        nextButton.disabled = true;
      }
    }

    function showPage(page) {
      renderPage(root, displayedReviews, page, perPage);
      updateNavButtons();
    }

    prevButton.addEventListener('click', function () {
      if (currentPage > 0) {
        currentPage -= 1;
        showPage(currentPage);
      }
    });

    nextButton.addEventListener('click', function () {
      if (currentPage < totalPages - 1) {
        currentPage += 1;
        showPage(currentPage);
      }
    });

    var cacheBuster = reviewsUrl.indexOf('?') > -1 ? '&' : '?';
    fetch(reviewsUrl + cacheBuster + 'cb=' + Date.now())
      .then(function (response) {
        if (!response.ok) throw new Error('Network response was not ok');
        return response.json();
      })
      .then(function (data) {
        var rawReviews = data.reviews || data;
        if (!Array.isArray(rawReviews)) throw new Error('Reviews JSON is not an array');

        allReviews = rawReviews.map(normalizeReview);
        displayedReviews = buildDisplayList(allReviews, mode, category);

        if (displayedReviews.length === 0) {
          grid.innerHTML =
            mode === 'category'
              ? '<p>There are no reviews to display for this category.</p>'
              : '<p>There are no reviews to display.</p>';
          countEl.removeAttribute('aria-busy');
          countEl.textContent = '0 Reviews';
          prevButton.disabled = true;
          nextButton.disabled = true;
          return;
        }

        totalPages = Math.ceil(displayedReviews.length / perPage);
        updateHeader(headerSource === 'all' ? allReviews : displayedReviews, countEl);
        showPage(currentPage);
      })
      .catch(function (error) {
        console.error('Error fetching or processing reviews:', error);
        grid.innerHTML = "<p>Sorry, we couldn't load the reviews at this time.</p>";
        countEl.removeAttribute('aria-busy');
        countEl.textContent = '0 Reviews';
      });
  }

  function initAll() {
    var roots = document.querySelectorAll('[data-lb-reviews]');
    roots.forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }
})();

